import { isEmpty } from "lodash";
import { Field, FieldResponse, FieldType, Form, Guest } from "types";
import { isAddonField, isHowYouHearAboutUs } from "./Field";
import { getFields } from "./Form";

/** An add-on answers with a quantity, numeric or string; a numeric zero is declined, treated as unanswered. */
const isFieldAnswered = (field: Field, response: FieldResponse) => {
    if (isAddonField(field.type)) {
        return Number(response.value) > 0;
    }

    return !isEmpty(response.value);
};

export const getQuestionnaireStatusIconColor = (form: Form, guest: Guest, isPrimaryGuest = false) => {
    const fields = getFields(form, guest.primary || isPrimaryGuest).filter((field) => {
        const isNotCheckbox = field.type !== FieldType.CHECKBOX;
        const isPickupExcluded = !(field.type === FieldType.PICKUP && field.organizerOnly);
        const isMarketingConsentExcluded = !(field.type === FieldType.MARKETING_CONSENT && field.organizerOnly);
        const isHowYouHearAboutUsExcluded = !(isHowYouHearAboutUs(field) && field.organizerOnly);

        return isNotCheckbox && isPickupExcluded && isMarketingConsentExcluded && isHowYouHearAboutUsExcluded;
    });

    let allQuestionsAnswered = true;
    let allRequiredQuestionsAnswered = true;
    for (const field of fields) {
        // check for every field if the response is recorded instead of comparing lengths of questions and answers
        // because there can be additional fields in the formResponse for OTA bookings
        const response = guest.formResponse?.fields.find((fieldResponse) => {
            return fieldResponse.label === field.label;
        });
        if (!response || !isFieldAnswered(field, response)) {
            if (field.required) {
                allRequiredQuestionsAnswered = false;
            }

            allQuestionsAnswered = false;
        }
    }

    if (allQuestionsAnswered) {
        return "success";
    }

    // All required questions answered, but questionnaire incomplete
    if (allRequiredQuestionsAnswered) {
        return "warning";
    }

    // At least 1 required question not answered
    return "danger";
};

export const getGuestsQuestionnaireStatus = (form: Form, guests: Guest[], color: string) => {
    return guests.some((guest) => getQuestionnaireStatusIconColor(form, guest) === color);
};
